import React from 'react';
import { Box } from '@mui/material';

import { CandidateDetailsAction } from '@constants';
import { IAvailableCandidate } from '@types';
import { candidateSubtitle, isAgileEngineer } from '@utils';
import { CandidateSection } from 'components/candidate/CandidateDetailSections/CandidateDetailSections';
import { PersonHeading } from 'components/candidate/CandidateDetailsHeader/PersonHeading';
import { DetailsDrawer } from 'components/candidate/CandidateDrawer/DetailsDrawer';
import { ActionBar } from 'components/candidate/CandidaterDetailsActionButton/ActionBar';
import { AgileEngineBenchStar } from './AgileEngineBenchStar';
import { AvailableCandidateActions } from './AvailableCandidateActions';
import { getAvailableCandidateSections } from './availableCandidateSections';

interface IAvailableCandidateDrawerProps {
  candidate: IAvailableCandidate | null;
  onClose: () => void;
  onOpenFullPage: (candidateId: string) => void;
  onAction: (candidateId: string, action: CandidateDetailsAction) => void;
  onLearnMore: (candidateId: string) => void;
  onOpenResume: (candidateId: string) => void;
}

export const AvailableCandidateDrawer: React.FC<
  IAvailableCandidateDrawerProps
> = ({
  candidate,
  onClose,
  onOpenFullPage,
  onAction,
  onLearnMore,
  onOpenResume,
}) => (
  <DetailsDrawer
    open={Boolean(candidate)}
    heading={
      candidate && (
        <PersonHeading
          name={candidate.name}
          country={candidate.country ?? ''}
          subtitle={candidateSubtitle(
            { profile: candidate },
            { withCountry: true },
          )}
          mark={isAgileEngineer(candidate) && <AgileEngineBenchStar />}
          variant="drawer"
        />
      )
    }
    actions={
      candidate && (
        <ActionBar>
          <AvailableCandidateActions
            candidate={candidate}
            variant="bar"
            onAction={onAction}
            onLearnMore={onLearnMore}
          />
        </ActionBar>
      )
    }
    onClose={onClose}
    onOpenFullPage={() => candidate && onOpenFullPage(candidate.id)}
  >
    {candidate && (
      <Box pb={12}>
        {getAvailableCandidateSections(candidate, onOpenResume).map(
          (section) => (
            <CandidateSection key={section.title} title={section.title}>
              {section.content}
            </CandidateSection>
          ),
        )}
      </Box>
    )}
  </DetailsDrawer>
);
